(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const products = new Map();

  function setup(root) {
    if (products.has(root)) return;
    const main = root.querySelector('.goc-product-main');
    const gallery = root.querySelector('.goc-gallery');
    const originalImages = gallery ? Array.from(gallery.children) : [];
    const originalMain = main ? {src: main.getAttribute('src'), srcset: main.getAttribute('srcset'), sizes: main.getAttribute('sizes'), alt: main.alt} : null;
    const select = root.querySelector('select[name="variant"]');
    const options = select ? Array.from(select.options).map(option => ({option, text: option.textContent})) : [];
    let enabled = false;

    const syncTitle = () => {
      const selected = select?.selectedOptions[0];
      const title = root.querySelector('[data-variant-title]');
      if (title && selected) title.textContent = mobile.matches ? selected.dataset.mobileTitle : selected.dataset.title;
    };

    const sync = () => {
      options.forEach(({option, text}) => { option.textContent = mobile.matches ? `${option.dataset.mobileTitle} — ${option.dataset.price}` : text; });
      syncTitle();
      if (!main || !gallery || enabled === mobile.matches) return;
      enabled = mobile.matches;
      if (!enabled) {
        gallery.replaceChildren(...originalImages);
        Object.entries(originalMain).forEach(([name, value]) => value === null ? main.removeAttribute(name) : main.setAttribute(name, value));
        return;
      }
      const images = [main.cloneNode(), ...originalImages];
      const buttons = images.map((image, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'goc-thumbnail';
        button.setAttribute('aria-label', `${root.dataset.galleryLabel} ${index + 1}`);
        button.setAttribute('aria-pressed', String(index === 0));
        if (index === 0) { image.className = ''; image.loading = 'lazy'; image.removeAttribute('fetchpriority'); }
        button.append(image);
        button.addEventListener('click', () => {
          main.src = image.src;
          if (image.srcset) main.srcset = image.srcset; else main.removeAttribute('srcset');
          main.sizes = '(max-width: 749px) calc(100vw - 40px), 45vw';
          main.alt = image.alt;
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
        return button;
      });
      gallery.replaceChildren(...buttons);
    };
    const onVariantChange = () => queueMicrotask(syncTitle);
    select?.addEventListener('change', onVariantChange);
    mobile.addEventListener('change', sync);
    products.set(root, () => { mobile.removeEventListener('change', sync); select?.removeEventListener('change', onVariantChange); });
    sync();
  }

  const init = () => {
    products.forEach((cleanup, root) => { if (!root.isConnected) { cleanup(); products.delete(root); } });
    document.querySelectorAll('gridone-catalog-product').forEach(setup);
  };
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
